"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const frontend_remote_modules_1 = require("frontend-remote-modules");
const getHostByScope_1 = require("../../utils/getHostByScope");
const MessageHubModule = (props) => {
    const { scope, domain, bu, realestateId, categoryId, siteId, hierarchyBgColor, } = props;
    return (react_1.default.createElement(frontend_remote_modules_1.Module, { isolated: false, name: "realestates", showUnmout: true, username: "Realestates", bu: bu, realestateId: realestateId, categoryId: categoryId, siteId: siteId, hierarchyBgColor: hierarchyBgColor || undefined, host: (0, getHostByScope_1.getHostByScope)({ domain, scope }), errorComponent: () => react_1.default.createElement("div", { className: "messages-hub-error" }) }));
};
exports.default = MessageHubModule;
